import React from 'react';
import classNames from 'classnames';
import { CSSTransitionGroup } from 'react-transition-group';
import { transition } from 'lib/helpers';

const BTN_CLASS = 'image-edit-btn';

export function Toolbar({ tools, activeMode, commiting, onToggle, onUndo, onCommit, onCancel }) {
	return (
		<div className="toolbar">
			{ tools.map(tool => (
				<ToolButton
					key={tool.mode}
					tool={tool}
					activeMode={activeMode}
					disabled={!tool.supported}
					onToggle={() => onToggle(tool)}>
				</ToolButton>
			))}
			<span className="split"></span>
			<button className={classNames(BTN_CLASS, "revocation")} onClick={onUndo}>撤销</button>
			<button className={classNames(BTN_CLASS, "cancle")} onClick={onCancel}>取消</button>
			<button className={classNames(BTN_CLASS, "sure")} onClick={onCommit}>确定</button>
			<CSSTransitionGroup {...transition.slide()}>
				{ commiting &&
					<div className="toolbox-msg">正在保存...</div>
				}
			</CSSTransitionGroup>
		</div>
	);
}

function ToolButton({ tool, activeMode, onToggle, disabled }) {
	const { mode, name, className } = tool;
	return (
		<button
			className={classNames(BTN_CLASS, className || mode, {
				actived: mode == activeMode,
				disabled,
			})}
			style={{
				pointerEvents: disabled ? 'none' : 'all',
				opacity: disabled ? 0.3 : 1,
				cursor: disabled ? 'not-allowed' : '',
			}}
			onClick={disabled ? null : onToggle}>
			{name}
		</button>
	);
}



// WEBPACK FOOTER //
// ./lib/editor/DraftEditor/plugins/imagePlugin/ImageEditor/Toolbar.jsx